import api from '@/api/api';

/**
 * Service para gerenciar observações de ordens de produção
 */
export const observacaoService = {
    
    /**
     * Buscar todas as observações de uma ordem
     * Retorna observações livres + observações vinculadas a movimentações
     * 
     * @param {number} idOrdem - ID da ordem de produção
     * @returns {Promise} Resposta com array de observações
     */
    async buscarPorOrdem(idOrdem) {
        try {
            const response = await api.get(`/ordem-observacoes/ordem/${idOrdem}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar observações da ordem:', error);
            throw error;
        }
    },

    /**
     * Criar uma observação livre (sem vínculo com movimentação)
     * 
     * @param {object} dados - Dados da observação
     * @param {number} dados.id_ordem - ID da ordem
     * @param {number} dados.id_chefe - ID do chefe
     * @param {string} dados.observacao - Texto da observação
     * @returns {Promise} Resposta com a observação criada
     */
    async criarObservacaoLivre(dados) {
        try {
            const response = await api.post('/ordem-observacoes/criar-livre', dados);
            return response.data;
        } catch (error) {
            console.error('Erro ao criar observação livre:', error);
            throw error;
        }
    },

    /**
     * Atualizar uma observação existente
     * Se for vinculada a movimentação, atualiza ambas as tabelas
     * 
     * @param {number} id - ID da observação
     * @param {string} observacao - Novo texto da observação
     * @returns {Promise} Resposta com a observação atualizada
     */
    async atualizarObservacao(id, observacao) {
        try {
            const response = await api.put(`/ordem-observacoes/${id}`, { observacao });
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar observação:', error);
            throw error;
        }
    },

    /**
     * Excluir uma observação
     * Se for vinculada a movimentação, apenas limpa a observação (não exclui a movimentação)
     * 
     * @param {number} id - ID da observação
     * @returns {Promise} Resposta de sucesso
     */
    async excluirObservacao(id) {
        try {
            const response = await api.delete(`/ordem-observacoes/${id}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao excluir observação:', error);
            throw error;
        }
    },

    /**
     * Buscar histórico de alterações de uma observação
     * 
     * @param {number} id - ID da observação
     * @returns {Promise} Resposta com histórico
     */
    async historicoObservacao(id) {
        try {
            const response = await api.get(`/ordem-observacoes/${id}/historico`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar histórico da observação:', error);
            throw error;
        }
    }
};

export default observacaoService;
